import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import '@chess/api-ending-case/colors.css';
import { LosingOpeningsCard, TITLE } from './LosingOpeningsCard.tsx';
import { LosingOpeningsAggregator } from './LosingOpeningsAggregator.ts';

// Openings card "Openings to work on" (2026-10-08; "Losing openings" before):
// registers its own aggregator with the game store, reads its result and
// registers `LosingOpeningsCard` as a card body (the section draws its
// frame) second in the Openings section
// (`home.section.openings`, order 20), which the Overview's Openings section
// and the Openings screen show. A row opens the library filtered to its
// games and to the last 30 days (`libraryLink`), so the library lists the
// games the card counted.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new LosingOpeningsAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path), 'opening'), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <LosingOpeningsCard loading />;
    return result ? <LosingOpeningsCard result={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.openings', Card, { order: 20, title: TITLE });
}
